import React, { useState } from "react";
import { IoChevronDown } from "react-icons/io5";
import faqStyle from "./CreatorFaq.module.css";

// FAQ answers for the chosen category, shown right under the dropdown so the
// creator can solve it without sending a ticket. Used by the signed-in Help &
// Support form and the login page's Contact Support form.
const RelatedFaqs = ({ items }) => {
  const [openIdx, setOpenIdx] = useState(null);
  if (!items.length) return null;
  return (
    <div className={faqStyle.related}>
      <p className={faqStyle.relatedTitle}>Is this your problem?</p>
      <ul className={faqStyle.relatedList}>
        {items.map((item, i) => {
          const open = openIdx === i;
          return (
            <li key={item.q} className={`${faqStyle.item} ${open ? faqStyle.itemOpen : ""}`}>
              <button
                type="button"
                className={faqStyle.question}
                onClick={() => setOpenIdx(open ? null : i)}
                aria-expanded={open}
              >
                <span>{item.q}</span>
                <IoChevronDown className={faqStyle.chev} />
              </button>
              {open && (
                <div className={faqStyle.answer}>
                  {item.a.map((p, j) =>
                    Array.isArray(p) ? (
                      <ul key={j}>
                        {p.map((li, k) => (
                          <li key={k}>{li}</li>
                        ))}
                      </ul>
                    ) : (
                      <p key={j}>{p}</p>
                    ),
                  )}
                </div>
              )}
            </li>
          );
        })}
      </ul>
      <p className={faqStyle.relatedFoot}>Still stuck? Fill in the rest of the form and we'll help.</p>
    </div>
  );
};

export default RelatedFaqs;
